import { render } from "./GenerateCompanyBalancesheetPdf.vue?vue&type=template&id=5979aa1c"
import script from "./GenerateCompanyBalancesheetPdf.vue?vue&type=script&lang=js"
export * from "./GenerateCompanyBalancesheetPdf.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__